import { MaskService } from '../../../../../shared/services/mask.service';
import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { NgxCurrencyDirective } from 'ngx-currency';

import { SelectPesquisavelComponent } from '../../../../../shared/components/select-pesquisavel/select-pesquisavel.component';
import { AutocompletePesquisavelComponent } from '../../../../../shared/components/autocomplete-pesquisavel/autocomplete-pesquisavel.component';
import { CategoriaFinanceira } from '../../../../../shared/services/models/financas/categoria-financeira.model';
import { environment } from '../../../../../../environments/environment';
import { TipoContatoEnum } from '../../../../../shared/enums/pessoa/tipo-contato.enum';
import { CampoObrigatorioStruct } from '../../../../../shared/services/structs/financas/campo-obrigatorio.struct';

@Component({
  selector: 'app-contas-receber-dados-gerais',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    NgxCurrencyDirective,
    SelectPesquisavelComponent,
  ],
  templateUrl: './contas-receber-dados-gerais.component.html',
  styleUrl: './contas-receber-dados-gerais.component.css',
})
export class ContasReceberDadosGeraisComponent implements OnInit {
  @Input() parentForm!: FormGroup;
  @Input() listaCategoriasFinanceiras: CategoriaFinanceira[] = [];
  @Input() currencyMask: any;
  @Input() camposObrigatorios: CampoObrigatorioStruct[] = [];

  public urlCliente = `${environment.urlApiPessoa}Lookup/listPessoaSelect?idTipoContato=${TipoContatoEnum.Cliente}`;
  public urlVendedor = `${environment.urlApiPessoa}Lookup/listVendedorSelect`;

  get dadosGeraisGroup(): FormGroup {
    return this.parentForm.get('dadosGerais') as FormGroup;
  }

  get idClienteControl(): any {
    return this.dadosGeraisGroup.get('idCliente');
  }
  get idCategoriaFinanceiraControl(): any {
    return this.dadosGeraisGroup.get('idCategoriaFinanceira');
  }
  get idVendedorControl(): any {
    return this.dadosGeraisGroup.get('idVendedor');
  }

  public isObrigatorio(nomeTecnico: string): boolean {
    return this.camposObrigatorios.some(c => c.nomeTecnico === nomeTecnico && c.isObrigatorio);
  }

  constructor() {}

  ngOnInit(): void {}

  onDateInput(event: Event, controlName: string): void {
    MaskService.onDateInput(event, this.dadosGeraisGroup.get(controlName));
  }
}
